<template>
	<div class="innerBox">
		<h2 class="mb-4">Input Kas Besar</h2>

		<div class="row rounded border border-secondary p-10" style="color:white;background-color:black;min-height:500px">
			<!-- <div class="col-3">
				<h5>Preview Gambar Faktur Pembayaran :</h5>

				<img :src="url" v-if="url" style="width:100%;height:auto;max-width:100%;"/>
			</div> -->
			<div class="col-12">
				<div class="row mt-4 text-center">
					<div class="col-3 middleDiv">
						<h5>Kategori <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.category"
							:options="options.category.map(x => x.code)"
                            :custom-label="opt => options.category.find(x => x.code == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>

				<div class="row mt-3 text-center" v-if="isRequired('workorder_code')">
					<div class="col-3 middleDiv">
						<h5>Work Order <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.workorder_code"
							:options="options.workorder.map(x => x.code)"
                            :custom-label="opt => options.workorder.find(x => x.code == opt).label"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
				<div class="row mt-3 text-center" v-if="isRequired('sparepart_id')">
					<div class="col-3 middleDiv">
						<h5>Sparepart <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.sparepart_id"
                            :disabled="!form.workorder_code"
							:options="options.sparepart.filter(x => !x.is_supplied_by_insurance).map(x => x.id)"
                            :custom-label="opt => options.sparepart.find(x => x.id == opt).name"
                            :allow-empty="false"
                            class="w-100"
						/>
					</div>
				</div>
                
				<div class="row mt-3 text-center" v-if="isRequired('supplier_id')">
					<div class="col-3 middleDiv">
						<h5>Supplier <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.supplier_id"
							:options="supplierList.map(x => x.id)"
                            :custom-label="opt => options.supplier.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
				</div>

				<div v-if="pending_payment">

					<div class="row mt-3 text-center" >
						<div class="col-3 middleDiv">
							<h5>Pilih Sparepart <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7 text-left" v-if="Object.keys(pending_payment).length > 0">
							<button class="btn btn-primary mb-3 mr-3" @click="clickAll()">Pilih Semuanya</button>
							<button class="btn btn-danger mb-3" @click="reset()">Reset</button>
							<div v-for="keys in Object.keys(pending_payment)" :key="keys" >
								<h5>{{keys}}</h5>
								<div class="ml-3" v-for="(dat , index) in pending_payment[keys]" :key="index">
									<input type="checkbox" :id="`${dat.sparepart_name}  - ${index} - ${dat.part_number}`" v-model="ongoing" :value="dat" style="width: 50px">
									<label :for="'selectBank'+index">
										{{dat.sparepart_name}} - {{dat.part_number}}
									</label>
								</div>
							</div>
						</div>
						<div class="col-7 text-left" v-else>
							<h5>No Pending Sparepart For Supplier.</h5>
						</div>
						
					</div>
					
					<div class="display:block;overflow-x:scroll">
						<table class="table mt-3 mb-3 w-100" style="background-color:white;">
							<thead>
								<th>No.</th>
								<th>No Polisi</th>
								<th>Nama Sparepart</th>
								<th>Deskripsi Sparepart</th>
								<!-- <th>Nama Supplier</th> -->
								<th>Jumlah</th>
								<th>Harga Total</th>
								<th>Harga Estimasi</th>
								<th>Markup</th>
								<th>Barang Diterima</th>
								<th>Aging</th>
								<th>Gambar</th>
							</thead>

							<tbody>
								<tr v-for="(sparepart, index) in ongoing" :key="ongoing.sparepart_name">
									<td>{{index + 1}}</td>
									<td>{{sparepart.registration}}</td>
									<td>{{sparepart.sparepart_name}}</td>
									<td>{{sparepart.part_number}}</td>
									<!-- <td>{{sparepart.name}}</td> -->
									<td>{{sparepart.amount}}</td>
									<td>{{numberWithCommas(parseFloat(sparepart.amount) * parseFloat(sparepart.price_per_item))}}</td>
									<td>{{numberWithCommas(parseFloat(sparepart.estimation_price))}}</td>
									<td>+ {{numberWithCommas(sparepart.markup)}}</td>
									<td>{{sparepart.time_of_arrival ? `${moment(sparepart.time_of_arrival).format('MMM DD,YYYY')}` : ''}}</td>
									<td>{{sparepart.aging}}</td>
									<td><button class="btn btn-primary" @click="showImage(sparepart.delivery_photo)"><i class="fa fa-image"></i></button></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div v-else-if="pending_payment_bahan">

					<div class="row mt-3 text-center" >
						<div class="col-3 middleDiv">
							<h5>Pilih Sparepart <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7 text-left" v-if="pending_payment_bahan.length > 0">
							<button class="btn btn-primary mb-3 mr-3" @click="clickAll()">Pilih Semuanya</button>
							<button class="btn btn-danger mb-3" @click="reset()">Reset</button>
							<div v-for="(dat , index) in pending_payment_bahan" :key="index" >
								<input type="checkbox" :id="`${dat.sparepart_name}  - ${index}`" v-model="ongoing" :value="dat" style="width: 50px">
								<label :for="'selectBank'+index">
									{{dat.sparepart_name}}
								</label>
							</div>
						</div>
						<div class="col-7 text-left" v-else>
							<h5>No Pending Bahan For Supplier.</h5>
						</div>
						
					</div>
					
					<div class="display:block;overflow-x:scroll">
						<table class="table mt-3 mb-3 w-100" style="background-color:white;">
							<thead>
								<th>No.</th>
								<th>Nama Bahan</th>
								<!-- <th>Nama Supplier</th> -->
								<th>Jumlah</th>
								<th>Harga Satuan Barang</th>
								<th>Harga Total</th>
								<th>Waktu Barang Diterima</th>
								<th>Diterima Oleh</th>
								
								<!-- <th>Gambar</th> -->
							</thead>

							<tbody>
								<tr v-for="(sparepart, index) in ongoing" :key="ongoing.sparepart_name">
									<td>{{index + 1}}</td>
									<td>{{sparepart.sparepart_name}}</td>
									<td>{{numberWithCommas(sparepart.amount)}}</td>
									<td>Rp. {{numberWithCommas(sparepart.price_per_item)}}</td>
									<td>Rp. {{numberWithCommas(parseFloat(sparepart.amount) * parseFloat(sparepart.price_per_item))}}</td>
									<td>{{sparepart.date_received ? `${moment(sparepart.date_received).format('MMM DD,YYYY')}` : ''}}</td>
									<td>{{sparepart.received_by}}</td>
									<!-- <td>{{sparepart.aging}}</td> -->
									<!-- <td><button class="btn btn-primary" @click="showImage(sparepart.delivery_photo)"><i class="fa fa-image"></i></button></td> -->
								</tr>
							</tbody>
						</table>
					</div>
				</div>
                
				<div class="row mt-3 text-center" v-if="isRequired('labourer_id')">
					<div class="col-3 middleDiv">
						<h5>Pekerja <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.labourer_id"
							:options="options.laborer.map(x => x.id)"
                            :custom-label="opt => options.laborer.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>

				<div class="row mt-3 text-center" v-if="isRequired('description')">
					<div class="col-3 middleDiv">
						<h5>Deskripsi <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<textarea 
							rows="5"
							class="w-100 form-control"
							v-model="form.description"
						/>
					</div>
				</div>
                
				<div class="row mt-3 text-center" v-if="isRequired('month')">
					<div class="col-3 middleDiv">
						<h5>Bulan <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.month"
							:options="options.month.map(x => x.value)"
                            :custom-label="opt => options.month.find(x => x.value == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
				<div class="row mt-3 text-center" v-if="isRequired('year')">
					<div class="col-3 middleDiv">
						<h5>Year <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.year"
							:options="options.year"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>
                
                <!-- AMOUNT, SALARY, OVERTIME, BONUS STARTS -->
				<div class="row mt-3 text-center" v-if="isRequired('salary')">
					<div class="col-3 middleDiv">
						<h5>Gaji <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.salary" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Gaji"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('overtime')">
					<div class="col-3 middleDiv">
						<h5>Lembur <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.overtime" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Lembur"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('bonus')">
					<div class="col-3 middleDiv">
						<h5>Bonus <span class="text-orange">**</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.bonus" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Bonus"/>
					</div>
				</div>
				<div class="row mt-3 text-center" v-if="isRequired('amount')">
					<div class="col-3 middleDiv">
						<h5>Jumlah Uang <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" :disabled="form.category == 'supplier_part'" v-model="form.amount" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Uang"/>
					</div>
				</div>
                <!-- AMOUNT, SALARY, OVERTIME, BONUS, ENDS -->

				<div class="row mt-3 text-center" v-if="isRequired('value_payable')">
					<div class="col-3 middleDiv">
						<h5>Pajak Yang Dibayar <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" v-model="form.value_payable" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Uang" disabled/>
					</div>
				</div>

				<div class="row mt-3 text-center" v-if="isRequired('proof_img')">
					<div class="col-3 middleDiv">
						<h5>Unggah Gambar Faktur Pembayaran <span class="text-red">*</span></h5>
						( Maximum 4 MB per File )
						
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<span v-if="fileError != ''" class="mb-2" style="color:red;font-weight:bold">{{fileError}}</span>
						<input type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize"/>
					</div>
                </div>
                
                <div class="row">
                    <div class="col-7 offset-6">
                        <p class="text-red m-0">* Harus di-isi</p>
                        <p class="text-orange m-0" v-if="form.category == 'labourer_wage'">** Isi 0 jika tidak ada</p>
                    </div>
                </div>

				<div class="row mt-4">
					
					<div class="offset-6 col-3">
						
						<!-- <button class="btn btn-danger w-100">Batal</button> -->
					</div>
					<div class="col-3" >
						<button class="btn btn-primary w-100" @click="submit">Selesai</button>
					</div>
				</div>
			</div>
		</div>

		<preview-image
			v-if="modal.showImage"
			@closeModal="modal.showImage = false"
			:title="'Gampar Sparepart'"
			:image="imagesList"
		></preview-image>

		
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import previewImage from '@/components/modal/previewImage'
import env from '@/env'
export default {
	components : {
		Multiselect,
		previewImage
	},
	data () {
		return {
            moment : moment,
            numberFields : ['salary', 'overtime', 'bonus', 'amount'],
            requiredFields : {
                supplier_part : ['category', 'supplier_id', 'amount', 'proof_img'],
				supplier_bahan : ['category', 'supplier_id', 'amount', 'proof_img'],
                labourer_wage : ['category', 'labourer_id', 'salary', 'overtime', 'bonus', 'proof_img'],
                donation : ['category', 'amount', 'proof_img'],
                tax_payable : ['category', 'month', 'year', 'value_payable'],
                other : ['category', 'amount', 'description', 'proof_img']
            },
			modal : {
				showImage : false
			},
			imagesList : null,
			form : {
                category : 'supplier_part',
                workorder_code : '',
                sparepart_id : '',
                supplier_id : '',
                labourer_id : '',
                description : '',
                month : moment().month(),
                year : moment().year(),

                amount : '',
                salary : '',
                overtime : '',
                bonus : '',
                value_payable : '',

                proof_img : '',
            },
            options : {
                category : [
                    {code : 'supplier_part', name : 'Supplier Part'},
					{code : 'supplier_bahan', name : 'Supplier Bahan'},
                    {code : 'labourer_wage', name : 'Gaji Karyawan'},
                    {code : 'donation', name : 'Donasi'},
                    {code : 'tax_payable', name : 'Pembayaran Pajak'},
                    {code : 'other', name : 'Other'},
                ],
                workorder : [],
                sparepart : [],
                supplier : this.$store.getters.getSupplier,
                laborer : this.$store.getters.getLaborer,
                month : this.$store.getters.getMonth,
                year : this.$store.getters.getYear,
            },
			file : null,
			url : null,
			fileError : '',
			labourerList : null,
			pending_payment : null,
			pending_payment_bahan : null,
			ongoing : [], 
			supplierList : []
		}
    },
	watch : {
        'form.month' : { handler : 'getTaxPayable' },
        'form.year' : { handler : 'getTaxPayable' },
		'form.category' : function () {
			this.pending_payment = null
			this.ongoing = []
			this.loadSupplierList()
		},
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
        },
		'form.salary' : function () {
			const result = this.form.salary.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.salary = result);
        },
		'form.overtime' : function () {
			const result = this.form.overtime.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.overtime = result);
        },
		'form.bonus' : function () {
			const result = this.form.bonus.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.bonus = result);
        },

        'form.workorder_code' : function () {
            this.form.sparepart_id = null;
            if (this.form.workorder_code) this.getListOfSparepart(this.form.workorder_code);
        },
		'form.supplier_id' : function () {
			this.pending_payment = null
			if(this.form.category == 'supplier_part') {
				if(!this.form.supplier_id)
					return
				this.loadVoucher(this.form.supplier_id)
			}
			else if (this.form.category == 'supplier_bahan') {
				if(!this.form.supplier_id)
					return
				this.loadVoucherBahan(this.form.supplier_id)
			}
		},
		'ongoing' : function () {
			let amountTotal = 0
			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let amount = parseFloat(this.ongoing[i].amount)
				let price = parseFloat(this.ongoing[i].price_per_item)

				amountTotal += (amount * price)
			}
			this.form.amount = this.numberWithCommas(amountTotal)
		}
	},
	mounted () {
        this.getListOfWorkOrder();
        this.getTaxPayable();
		this.loadSupplierList()
	},
	methods : {
		loadSupplierList () {
			let type = ''
			this.form.category == 'supplier_part' ? type =  'P' : this.form.category == 'supplier_bahan' ? type = 'B' : ''
			if(type == '') 
				return
			this.$http.get(`/api/v1/purchase-order/supplier-voucher/supplier-list?type=${type}`)
			.then((resp) => {
				this.supplierList = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			})
		},
		clickAll() {
			this.ongoing = JSON.parse(JSON.stringify(this.pending_payment ? this.pending_payment : this.pending_payment_bahan))
		},
		reset() {
			this.ongoing = []
		},
		showImage (imagesList) {
			this.imagesList = imagesList
			this.modal.showImage = true
		},
		loadVoucherBahan (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher/bahan?supplier_id=${supplier_id}`)
			.then((resp) => {
				this.pending_payment_bahan = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			})
		},
		loadVoucher (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher?supplier_id=${supplier_id}`)
			.then((resp) => {
				let pending_payment = resp.data.data
				let newObj = {}

				for(var i = 0 ; i < pending_payment.length ; i++) {

					let ppn = pending_payment[i].ppn_included

					let without_ppn = pending_payment[i].without_ppn

					if(ppn == 0 && !without_ppn) {
						pending_payment[i].price_per_item = parseFloat(pending_payment[i].price_per_item) * 1.1
						
					}

					pending_payment[i].estimation_price = (parseFloat(pending_payment[i].price_per_item) + parseFloat(pending_payment[i].markup)) *  parseFloat(pending_payment[i].amount)



					if(!pending_payment[i].time_of_arrival) {
						pending_payment[i].aging = '-'
					}
					else {
						let b = moment(pending_payment[i].time_of_arrival)
						let a = moment()

						var years = a.diff(b, 'year');
						b.add(years, 'years');

						var months = a.diff(b, 'months');
						b.add(months, 'months');

						var days = a.diff(b, 'days');

						pending_payment[i].aging = `${years > 0 ? years + ' T' : ''} ${months > 0 ? months + ' B' : ''} ${days > 0 ? days + ' H' : ''}`
					}

					if(pending_payment[i].delivery_photo.includes(',')) {
						pending_payment[i].delivery_photo = pending_payment[i].delivery_photo.split(',')
						for(var j = 0 ; j < pending_payment[i].delivery_photo.length ; j++) {
							if(!pending_payment[i].delivery_photo[j].includes(env.baseImage))
								pending_payment[i].delivery_photo[j] = env.baseImage + '/' + pending_payment[i].delivery_photo[j]
						}
					}
					else {
						pending_payment[i].delivery_photo = [env.baseImage + '/' + pending_payment[i].delivery_photo]
					}

					!newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] ? newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] = [pending_payment[i]] : newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name].push(pending_payment[i])
				}
				this.pending_payment = newObj
			})
			.catch((err) => {
				console.log(err)
			})
		},
        isRequired (field) {
            return (this.requiredFields[this.form.category].indexOf(field) !== -1) ? true : false
        },
        resetForm () {
            for (var i in this.form) {
                if (
                    i !== 'category' &&
                    i !== 'month' &&
                    i !== 'year' &&
                    i !== 'value_payable'
                ) this.form[i] = ''
            }

			this.pending_payment = null
			this.ongoing = null
        },
		getListOfWorkOrder () {
			this.$http.get('/api/v1/masterData/workorder?pagination=false')
			.then((resp) => {
				this.options.workorder = resp.data.data.map(x=>{return{code:x.form_code, label:`${x.form_code} - ${x.no_polisi}`}});
			})
			.catch((err) => { console.log(err) })
		},
        getListOfSparepart (workorder) {
            this.$http.get(`/api/v1/workorder-estimation/${workorder}`)
            .then((resp)=>{
                this.options.sparepart = resp.data.data.estimations.filter(x=>x.sparepart_type=='P'&&x.is_supplied_by_insurance!=1).map(x=>{return {id:x.id, name:x.sparepart_name}})
            })
            .catch((err)=>{console.log(err)})
        },
		validateSize(data) {
			var file = data.target.files[0];

			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				this.fileError = "Limit Size Gambar 8 MB";
				return false;
			}

			this.fileError = "";
			this.file = file ;
			this.url = URL.createObjectURL(file);

			return true;
		},
		async uploadImage () {
			let formData = new FormData()
			let image = null

			formData.append('work_order', this.file)

			
			let response = await this.$http.post(env.urlStart + '/api/v1/workorder/image', formData, {headers : {"Content-Type":'multipart/form-data'}})
			
			image = response.data.data.filename

			return image
        },
        async evaluateForm () {
            let errors = []
            let keys = this.requiredFields[this.form.category];

            //Check valid
            for(var i in keys) {
				if(keys[i] == 'proof_img') {
					if(!this.file) {
						errors.push('Harap Pilih Gambar Faktur Pembayaran Terlebih Dahulu.')
					}
					else {
						let image = await this.uploadImage()
						this.form.proof_img = image
					}
				}
				else if(this.form[keys[i]] == '' || this.form[keys[i]] == null) {
					errors.push(`${this.translate(keys[i])} Wajib Dipilih Atau Diisi`)
				}
            }

            //If any error is detected
            if (errors.length > 0) {
                this.$store.dispatch('triggerAlert', [false, errors]);
                return null;
            }

            //Create object for 'form', get all it's keys
            let data = JSON.parse(JSON.stringify(this.form));
            let formKeys = Object.keys(this.form);

            //Cleanse commas(,) on number fields
            for (var i in this.numberFields) data[this.numberFields[i]] = parseFloat(data[this.numberFields[i]].split(',').join(''))

            //Cleanse form field where it is not needed
            for (var i in formKeys) if (keys.indexOf(formKeys[i]) === -1) delete data[formKeys[i]];

            return data;

        },
		async submit() {
            //If tax payable, refer to another function
            if (this.form.category == 'tax_payable') {
                this.commitTaxTransaction();
                return;
            }

		    let form = await this.evaluateForm()

            //Error detected
            if (!form) return;

			if(this.form.category == 'supplier_part') {
				this.commitSupplierPayment(form)
				return
			}
			else if (this.form.category == 'supplier_bahan') {
				this.commitSupplierBahanPayment(form)
				return
			}

            this.fileError = ''
            this.$http.post(`/api/v1/treasury/ledger` , form)
            .then((resp) => {
                this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
                this.resetForm();
            })
            .catch((err) => {
                console.log(err)
            })
        },
		async getLastIndex (supplier_id , type) {
			try {
				let response = await this.$http.post('/api/v1/treasury/supplier-voucher/index?supplier_id=' + supplier_id , {type : type})
				// console.log(response)
				return response.data.data.sv_id	
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Fetching Supplier Code. Please Try Again Later.'])
				console.log(err)
			}
		},
		async commitSupplierBahanPayment (form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'BAHAN')

			if(!svCounter) return

			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let curr = this.ongoing[i]

				let data = Object.assign({} , form)

				data.transaction_id = curr.transaction_id
				data.sparepart_id = curr.spare_part_id
				data.sparepart_name = curr.sparepart_name
				data.amount = parseFloat(curr.price_per_item) * parseFloat(curr.amount)
				data.sv_id = svCounter
				this.$http.post(`/api/v1/treasury/ledger` , data)
				.then((resp) => {
					if(length == counter)
						this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
					else
						counter++
					this.resetForm();
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		async commitSupplierPayment(form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'PART')

			if(!svCounter) return
			

			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let curr = this.ongoing[i]

				let data = Object.assign({} , form)

				data.workorder_code = curr.form_code
				data.sparepart_id = curr.sparepart_id
				data.sparepart_name = curr.sparepart_name
				data.amount = parseFloat(curr.price_per_item) * parseFloat(curr.amount)
				data.estimation_id = curr.estimation_id
				data.sv_id = svCounter
				this.$http.post(`/api/v1/treasury/ledger` , data)
				.then((resp) => {
					if(length == counter)
						this.$store.dispatch('triggerAlert', [true, `Kas Besar Berhasil di Masukkan.`]);
					else
						counter++
					this.resetForm();
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},

		translate (word) {
            let dictionary = {
                category : 'Kategori',
                workorder_code : 'Work Order',
                sparepart_id : 'Sparepart',
                supplier_id : 'Supplier',
                labourer_id : 'Pekerja',
                description : 'Deskripsi',
                salary : 'Gaji',
                overtime : 'Lembur',
                bonus : 'Bonus',
                amount : 'Jumlah Uang',
                proof_img : 'Gambar Faktur Pembayaran',
            }

			return dictionary[word]
        },
        getTaxPayable () {
            this.$http.get(`/api/v1/treasury/tax-payable?month=${this.form.month}&year=${this.form.year}`)
            .then((resp)=>{
                this.form.value_payable = this.numberWithCommas(resp.data.data);
            })
            .catch((err)=>{console.log(err)})
        },
        commitTaxTransaction () {
            this.$http.post(`/api/v1/treasury/tax-payable?month=${this.form.month}&year=${this.form.year}`)
            .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, `Pajak berhasil dibayar.`]);
                this.resetForm();
            })
            .catch((err)=>{console.log(err)})
        },
	}
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
</style>